module.exports = __webpack_public_path__ + "img/brief-img.a38994c2.png";